var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "346.000000pt",
    height: "346.000000pt",
    viewBox: "0 0 346.000000 346.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\r\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\r\n", /*#__PURE__*/React.createElement("meta", {
    name: "Producer",
    content: "Online-Convert"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,346.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1720 l0 -1330 1730 0 1730 0 0 70 0 70 -880 0 -880 0 0 1260 0 1260 -850 0 -850 0 0 -1330z m1500 -20 l0 -1170 -90 0 -90 0 0 1080 0 1080 -475 0 -475 0 0 -1080 0 -1080 -90 0 -90 0 0 1170 0 1170 655 0 655 0 0 -1170z m-306 -96 c58 -59 14 -164 -69 -164 -51 0 -95 44 -95 96 0 85 104 128 164 68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1910 1780 l0 -930 775 0 775 0 0 930 0 930 -775 0 -775 0 0 -930z m690 460 l0 -280 -255 0 -255 0 0 280 0 280 255 0 255 0 0 -280z m670 0 l0 -280 -260 0 -260 0 0 280 0 280 260 0 260 0 0 -280z m-670 -805 l0 -415 -255 0 -255 0 0 415 0 415 255 0 255 0 0 -415z m670 0 l0 -415 -260 0 -260 0 0 415 0 415 260 0 260 0 0 -415z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/newLogo.60e238cb7d390ad75fee63ee24b442d9.svg";
export { ForwardRef as ReactComponent };